import { Injectable, inject } from '@angular/core';

import { InspectionStyleDBService } from '../db/inspection-style-db-service';
import { Resolve } from '@angular/router';
import { InspectionStyleDto } from '@core/api';

@Injectable()
export class InspectionStylesResolver implements Resolve<InspectionStyleDto[]> {
  private inspectionStylesDBService = inject(InspectionStyleDBService);

  public resolve() {
    return this.inspectionStylesDBService.getInspectionStyles();
  }
}
